import en from "./localeEn";
import es from "./localeEs";
import pt from "./localePt";
export var DiplomasLocalesBundle = {
  es: es,
  pt: pt,
  en: en
};